export const OTHER_REASON_VALUE = "OTHER";

const CANCELLATION_REASON_ROWS = `
DELIVERY_TIMING_TOO_LONG|Delivery timing too long|RC_VEHICLE_LEAD_TIME_NOT_ACCEPTABLE
NOT_IN_PRICE_RANGE|Not in price range/Funding Challenge|RC_CHANGED_FINANCE_PLAN
DUPLICATE|Duplicate|RC_SOURCED_THE_VEHICLE_SOMEWHERE_ELSE
BOUGHT_DIFFERENT_VEHICLE_FORD|Bought different vehicle - Ford|RC_CUSTOMER_SELECTED_ANOTHER_MODEL
BOUGHT_DIFFERENT_VEHICLE_OTHER_BRAND|Bought different vehicle - other brand|RC_CUSTOMER_SELECTED_ANOTHER_BRAND
CHANGED_MIND_PERSONAL|Changed mind/Personal|RC_CUSTOMER_CIRCUMSTANCES_HAVE_CHANGED
CUSTOMER_UNRESPONSIVE|Customer Unresponsive|RC_UNABLE_TO_CONTACT_CUSTOMER
DATA_ENTRY_SYSTEM_ERROR|Data entry/system error|RC_ERROR
VEHICLE_UNAVAILABLE|Vehicle unavailable|RC_INABILITY_TO_COMPLETE_PURCHASE
${OTHER_REASON_VALUE}|Other|RC_OTHER
`
  .trim()
  .split("\n");

export const CANCELLATION_REASONS = CANCELLATION_REASON_ROWS.map((row) => {
  const [value, label, code] = row.split("|");
  return { value, label, code };
});

export const getCancellationReason = (value) =>
  CANCELLATION_REASONS.find((reason) => reason.value === value);

export const buildDealerRejectedReason = (
  reasonValue,
  otherReasonText = ""
) => {
  const reason = getCancellationReason(reasonValue);

  if (!reason) {
    throw new Error("Invalid cancellation reason");
  }

  if (reasonValue === OTHER_REASON_VALUE) {
    return `${reason.code}: '${otherReasonText.trim()}'`;
  }

  return reason.code;
};
